import { SITE_URL } from "./site";

// Organization / ProfessionalService structured data for rich results and
// local SEO. Keep contact details in sync with data/content/footerContent.yml
// and the contact page (NAP consistency).
export const organizationJsonLd = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  name: "Practical",
  url: SITE_URL,
  logo: SITE_URL + "/icons/android-chrome-512x512.png",
  image: SITE_URL + "/icons/android-chrome-512x512.png",
  email: "office@practical.at",
  telephone: "+43 1 600 73 50",
  areaServed: "AT",
  address: {
    "@type": "PostalAddress",
    addressCountry: "AT"
  },
  availableLanguage: ["de", "en"],
  knowsLanguage: ["de", "en"]
};
